const Emitter = require('mn-utils/Emitter');
const emitterBehave = require('mn-utils/Emitter/behave');
const startsWith = require('mn-utils/startsWith');
const delay = require('mn-utils/delay');
const {
  USER_TYPE_ADMIN,
} = require('../constants');
const {
  LINK_START_LAST,
  LINK_SECURITY_VERIFICATION,
  LINK_RESET_SECURITY_VERIFICATION,
  LINK_SIGN_IN,
  LINK_SETTINGS,
  LINK_START_STEP,
} = require('../constants/links');
const {
  replaceLocation,
  replaceLocationLazy,
} = require('../router');
const {
  localStore,
} = require('../stores');
const {
  apiRequest,
  apiRequestAdmin,
} = require('../api/ws');
const {
  apiAuthSignUpMerchant,
  apiAuthSignIn,
  apiAuthSignOut,
  apiAuthEmailConfirm,
  apiAuthResendConfirmationV2,
  // apiAuthUserDelete,
  checkSessionWithoutLoading,
  decorateReconnectIfSession,
  decorateReconnect,
  auth$,
} = require('../api/_auth');
const {
  openPopupInfo,
} = require('./popup');


export const login$ = localStore('email', '');
export function handleChangeEmail(e) {
  login$.emit(e.target.value);
}


export const cachedAccount$ = new Emitter();
export const loadingSignUp$ = new Emitter();
export const loadingSignIn$ = new Emitter();
export const loadingSignOut$ = new Emitter();
export const loadingAccount$ = Emitter.some([
  loadingSignUp$,
  loadingSignIn$,
  loadingSignOut$,
]);
const {
  emit: loadingSignOutEmit,
} = loadingSignOut$;


export function onAccount(account) {
  cachedAccount$.emit(account);
  if (!account) {
    emitAccount(0);
    return true;
  }
  const path = window.location.pathname;
  if (!account.enabled) {
    emitAccount(account);
    startsWith(path, LINK_START_STEP + '/') || replaceLocationLazy({
      path: LINK_START_LAST,
    });
    return true;
  }
  if (account.need_tfa) {
    emitAccount(0);
    startsWith(path, LINK_SECURITY_VERIFICATION)
      || startsWith(path, LINK_RESET_SECURITY_VERIFICATION)
      || replaceLocationLazy({
        path: LINK_SECURITY_VERIFICATION,
      });
    return true;
  }
  if (account.need_change_password) {
    startsWith(path, LINK_SETTINGS) || replaceLocationLazy({
      path: LINK_SETTINGS,
    });
    openPopupInfo(['Please change your password']);
  }
  emitAccount(account);
}

export function accountUpdate() {
  loadingSignOutEmit(1);
  return checkSessionWithoutLoading().finally((error, account) => {
    onAccount(account);
    loadingSignOutEmit(0);
  });
}

export function isUserAccessed(accessName) {
  const user = account$.getValue();
  const settings = user && user.access_settings;
  return user && (user.admin || user.merchant || settings && settings[accessName]);
}

export const account$ = emitterBehave(accountUpdate, {
  signIn: decorateByLoadingEmit(
      decorateReconnect(apiAuthSignIn),
      loadingSignIn$,
      (account, params) => {
        apiRequest.reset();
        // apiRequestAdmin.reset();
      },
  ),
  signUpMerchant: decorateByLoadingEmit(
      decorateReconnect(apiAuthSignUpMerchant),
      loadingSignUp$,
  ),
  signOut: decorateByLoadingEmit(
      decorateReconnectIfSession(apiAuthSignOut),
      loadingSignOut$,
      () => {
        emitAccount(0);
        replaceLocation({
          path: LINK_SIGN_IN,
        });
        // delay(() => {
        //   window.location.reload();
        // }, 100);
      },
  ),
  emailConfirm: decorateByLoadingEmit(
      decorateReconnect(apiAuthEmailConfirm),
      loadingSignIn$,
  ),
  resendConfirmationV2: decorateByLoadingEmit(
      decorateReconnect(apiAuthResendConfirmationV2),
      loadingSignIn$,
  ),
});
const {
  emit: emitAccount,
} = account$;

auth$.on((auth) => {
  auth === 0 && emitAccount(0);
});


export const version$ = account$.map('version');
export const accountType$ = account$.map('account_type');
export const currency$ = account$.map('fiat_code');
export const username$ = account$.map('username');
export const accessSettings$ = account$.map('access_settings');


export const hasAdmin$ = accountType$.is(USER_TYPE_ADMIN);


function decorateByLoadingEmit(request, loading$, onResponse) {
  let promise;
  return (emit, params, getValue) => {
    return loading$.getValue()
      ? promise
      : (
        loading$.emit(1),
        promise = request(params).finally((error, response) => {
          error || onResponse && onResponse(response, params, getValue);
          loading$.emit(0);
        })
      );
  };
}
